import forge from 'node-forge'

export default class ConvertBytes {
  bufferToBase64(arrayBuffer) {
    let buf = new Uint8Array(arrayBuffer)
    let binstr = Array.prototype.map
      .call(buf, function(ch) {
        return String.fromCharCode(ch)
      })
      .join('')
    return btoa(binstr)
  }

  base64ToBuffer(base64) {
    let binstr = atob(base64)
    let buf = new Uint8Array(binstr.length)
    Array.prototype.forEach.call(binstr, function(ch, i) {
      buf[i] = ch.charCodeAt(0)
    })
    return buf
  }

  buildHash(fileUrl) {
    return new Promise(async function(resolve, reject) {
      var reader = new FileReader()
      const blob = await fetch(fileUrl).then(r => r.blob())
      reader.onloadend = function() {
        const converter = new ConvertBytes()
        const strBase64 = converter.bufferToBase64(reader.result)
        const md = forge.md.sha256.create()
        md.update(strBase64)
        const computeHash = md.digest().toHex()
        resolve({computeHash})
      }
      reader.readAsArrayBuffer(blob)
    })
  }
}
